import { useEffect, useState } from "react";
import * as config from "../../../config/config";
import { getHomepageBanner } from "../../../redux/actions/job_action";
import {
  BannerCta,
  BannerFrame,
  BannerImage,
  DecoyGrid,
  DiscoverCompaniesContainer,
  GradientOverlay,
  LinkStyled,
  MobileBannerImage,
  OuterContainer,
  TitleContainer,
  TitleStyled,
} from "./styles";

const FALLBACK_WEB_BANNER = `${config.assetDomain}/images/hiredly/homepage/discovery-celcomdigi-banner.png`;
const FALLBACK_MOBILE_BANNER = `${config.assetDomain}/images/hiredly/homepage/discovery-celcomdigi-banner-mobile.png`;

function HomepageDiscoverCompanies(props) {
  const [discoverData, setDiscoverData] = useState(null);

  useEffect(() => {
    const fetchHomepageBanner = async () => {
      try {
        const result = await getHomepageBanner();
        if (result && result.attributes) {
          setDiscoverData(result.attributes);
        }
      } catch (error) {
        console.error("Error fetching homepage banner:", error);
      }
    };

    fetchHomepageBanner();
  }, []);

  const title = discoverData?.title?.trim() || "";
  const buttonText = discoverData?.buttonText?.trim() || "";
  const companyLink = discoverData?.companyLink || "/companies";
  const webImageUrl = discoverData?.webImage?.data?.attributes?.url;
  const mobileImageUrl = discoverData?.mobileImage?.data?.attributes?.url;

  const webBanner = webImageUrl || FALLBACK_WEB_BANNER;
  const mobileBanner = mobileImageUrl || FALLBACK_MOBILE_BANNER;
  const bannerAlt = title
    ? title.replace(/<[^>]*>/g, " ").trim()
    : "Discover companies";
  const showOverlay = Boolean(title || buttonText);

  // Support HTML line breaks from CMS (e.g. <br/>), with double-space fallback
  const hasHtml = /<[a-z][\s\S]*>/i.test(title);
  const titleHtml = hasHtml
    ? title
    : title
        .split("  ")
        .filter((part) => part.trim() !== "")
        .join("<br/>");

  return (
    <OuterContainer>
      <DiscoverCompaniesContainer>
        <LinkStyled href={companyLink}>
          <BannerFrame>
            <BannerImage src={webBanner} alt={bannerAlt} />
            <MobileBannerImage src={mobileBanner} alt={bannerAlt} />
            {showOverlay && (
              <GradientOverlay>
                {title && (
                  <TitleContainer>
                    <TitleStyled
                      dangerouslySetInnerHTML={{ __html: titleHtml }}
                    />
                  </TitleContainer>
                )}
                {buttonText && (
                  <BannerCta id="homepage-discover-now-button">
                    {buttonText}
                  </BannerCta>
                )}
              </GradientOverlay>
            )}
          </BannerFrame>
        </LinkStyled>
      </DiscoverCompaniesContainer>
      <DecoyGrid />
    </OuterContainer>
  );
}

export default HomepageDiscoverCompanies;
